(function () {
    function buildNotePayload() {
        const noteEl = document.getElementById('wd-selected-options-note');
        if (!noteEl) return;


        // get color
        const colorValue = document.querySelector('wd-product-variant-picker input[name="color"]:checked')?.getAttribute("textvalue") ||
            window.current_product.color_value;

        // get sibling variant description
        const siblingVariantDescription =
            document.querySelector('wd-product-variant-picker .wd-swatch:has(input[name="handle"]:checked) .wd-swatch--radio-label')
                ?.innerText || undefined

        // get railing variant
        const railingVariantDescription =
            document.querySelector('wd-product-variant-picker input[name="railing"]:checked')?.value ? "כולל מעקה" : undefined

        // get mattress variant
        const mattressCount =
            document.querySelectorAll('wd-product-variant-picker input[name^="m"][id^="m"][value]:checked:not(.none)').length || undefined

        // build payload
        const noteParts = [colorValue, siblingVariantDescription, railingVariantDescription, mattressCount ? `+ ${mattressCount} מזרנים` : undefined]
            .filter(Boolean)
            .join(' • ');

        noteEl.innerText = noteParts;
    }
    window.addEventListener('variantChange', buildNotePayload);
    buildNotePayload();
})()